export function initSolutionsCollage(){

    var solutionsCollage = Barba.BaseView.extend({
    namespace: 'le-dosage',
    onEnter: function() {
        // The new Container is ready and attached to the DOM.
    },
    onEnterCompleted: function() {
        // The Transition has just finished.
    }
  });
  // Don't forget to init the view!
  solutionsCollage.init();

}